/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React from 'react';
import PropTypes from 'prop-types';
import Button from '@ba-ui-toolkit/button';
import arrowLeft16 from '@ba-ui-toolkit/ba-graphics/dist/icons-js/arrow--left_16';
import arrowRight16 from '@ba-ui-toolkit/ba-graphics/dist/icons-js/arrow--right_16';
import styles from './AlertNavigatorButtons.scss';

const alertNavigatorButtonsClassName = styles.alertNavigatorButtonsClassName.replace(/"/g, '');

export default function AlertNavigatorButtons(props) {
	const { alertsLength, onPrev, onNext } = props;
	const currentAlert = props.currentAlert + 1;

	return (
		<div className={alertNavigatorButtonsClassName}>
			<Button
				varient="icon"
				icon={arrowLeft16.id}
				disabled={currentAlert === 1}
				onClick={onPrev}
			/>
			<Button
				varient="icon"
				icon={arrowRight16.id}
				disabled={currentAlert === alertsLength}
				onClick={onNext}
			/>
		</div>
	);
}

AlertNavigatorButtons.propTypes = {
	currentAlert: PropTypes.number.isRequired,
	alertsLength: PropTypes.number.isRequired,
	onPrev: PropTypes.func,
	onNext: PropTypes.func,
};

AlertNavigatorButtons.defaultProps = {
	currentAlert: 0,
	alertsLength: 0,
};
